import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IN_APP } from 'constants/messageMediums';
import { fetchMobileApps } from 'modules/mobileApps/actions';
import { selectMobileApps } from 'modules/mobileApps/selectors';
import BaseSendEditor, { BaseSendEditorProps } from '../BaseSendEditor';

export const SendInAppEditor = (props: BaseSendEditorProps) => {
  const dispatch = useDispatch();

  /* Show iOS and Android apps as well as web apps regardless of integration status */
  const mobileApps = useSelector(selectMobileApps);

  /* Selective in-app will be visible if there is at least one selectable mobile app */
  const shouldShowSelectiveInApp = mobileApps?.length > 0;

  useEffect(() => {
    dispatch(fetchMobileApps());
  }, []);

  return (
    <BaseSendEditor
      shouldShowDisplayPriority
      shouldShowDeliverySectionHeader
      shouldShowQuietHours
      shouldShowRateLimit
      {...props}
      shouldShowSelectiveInApp={shouldShowSelectiveInApp}
      messageMedium={IN_APP}
      mobileApps={mobileApps}
    />
  );
};
